import sipClient from './client';
// const apiURLForClip = 'https://sip-clip-search-default.use.eks.eng.sip.pac.cloud.synchronoss.net';
// const apiURLForClip = 'https://sip-clip-search1-default.use.eks.eng.sip.pac.cloud.synchronoss.net';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
    },
};
const apiType = 'sip';
const isNotHost = true;
export const imgSearchForCheckSumsPostApi = async (body, logger) => {
    if (logger) {
        sipClient.setLogger(logger);
    }
    const url = `/text_to_image`;
    return sipClient.post(url, apiType, { data: body, ...opts });
};
